/*
 * Single-row shipping fee, arm c of the combo-offer A/B (snippets/seatfit-single-row-shipping.liquid).
 * Keeps the cart in this shape: when the shopper's arm is 'c' (cookie sf_combo_ab) and the seat lines add up to
 * exactly ONE row (Front / Rear / Third Row = 1, Full Set = 2, times quantity), one fee line sits nested under that
 * seat line (Shopify nested cart lines: removing the seat removes the fee); any other cart has no fee line.
 * Reconciles after every cart drawer re-render, like seatfit-free-addons.js. A refused add is not retried in the
 * same page view, and the fee is never added as a loose line (nesting refused = no fee, never a stray charge).
 */
(function () {
  'use strict';
  if (window.SeatFitSingleRowShipping) return;
  var cfgEl = document.getElementById('sf-single-row-shipping-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('[SeatFit] single-row shipping config', e); return; }
  var refused = false, busy = false, again = false, lastDom = null;

  function arm() {
    var m = document.cookie.match(/(?:^|; )sf_combo_ab=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  // Same rule as seatfit-c-combo-offer.js, on EVERY page (this file loads with the cart drawer): a visit tagged by a
  // source that promises free shipping (Google, Klaviyo email, excluded Meta campaigns) takes the shopper out of the
  // test for good, so the fee line goes even when the link lands on the home page or the cart, not a seat page.
  (function leaveTestOnFreeShippingSources() {
    try {
      if (arm() !== 'c') return;
      var q = new URLSearchParams(window.location.search), src = String(q.get('utm_source') || '').toLowerCase();
      var tagged = !!src || q.has('gclid') || q.has('gbraid') || q.has('wbraid');
      var meta = /^(facebook|fb|ig|instagram|meta|an|msg)$/.test(src) || q.has('fbclid');
      var excluded = cfg.excludeCampaigns && new RegExp(cfg.excludeCampaigns, 'i').test(q.get('utm_campaign') || '');
      if (tagged && (!meta || excluded)) document.cookie = 'sf_combo_ab=n; path=/; max-age=' + (30 * 86400) + '; SameSite=Lax';
    } catch (e) { /* keep the stored arm */ }
  })();
  function isSeat(i) { return cfg.seatHandles.indexOf(i.handle) > -1 && !i.parent_relationship; }
  function isFee(i) { return i.handle === cfg.handle; }
  function setOf(line) {
    var o = (line.options_with_values || []).filter(function (x) { return /seat set/i.test(x.name); })[0];
    return o ? o.value : '';
  }
  function rows(seats) {
    return seats.reduce(function (n, s) { return n + (cfg.rowsBySet[setOf(s)] || 1) * s.quantity; }, 0);
  }

  // What to change: { remove: [lines], fix: [line -> qty 1], add: parent line or null }.
  function plan(cart) {
    var items = cart.items || [], seats = items.filter(isSeat), fees = items.filter(isFee);
    var out = { remove: [], fix: [], add: null };
    var parent = arm() === 'c' && rows(seats) === 1 ? seats[0] : null;
    var kept = false;
    fees.forEach(function (f) {
      var under = parent && f.parent_relationship && f.parent_relationship.parent_key === parent.key;
      if (under && !kept) { kept = true; if (f.quantity !== 1) out.fix.push(f); } else out.remove.push(f);
    });
    if (parent && !kept && !refused) out.add = parent;
    return out;
  }

  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() {
    var d = drawer();
    try {
      if (d && typeof d.getSectionsToRender === 'function') {
        var ids = d.getSectionsToRender().map(function (s) { return s.section || s.id; }).filter(Boolean);
        if (ids.length) return ids;
      }
    } catch (e) { /* defaults below */ }
    return ['cart-drawer', 'cart-icon-bubble'];
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body) }).then(function (r) { return r.json().then(function (j) { j._ok = r.ok; return j; }); });
  }
  // Open drawer: Shrine's renderContents. Closed drawer: swap the HTML only (renderContents would open it).
  function paint(state) {
    var d = drawer();
    if (!d || !state || !state.sections) return;
    try {
      if (d.classList.contains('active') && typeof d.renderContents === 'function') { d.renderContents(state); return; }
      d.getSectionsToRender().forEach(function (s) {
        var id = s.section || s.id;
        var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
        var html = state.sections[id];
        if (el && html) el.innerHTML = d.getSectionInnerHTML(html, s.selector);
      });
    } catch (e) { console.warn('[SeatFit] single-row shipping paint', e); }
  }
  function change(line, qty, withSections) {
    var body = { id: line.key, quantity: qty };
    if (withSections) { body.sections = sectionIds(); body.sections_url = window.location.pathname; }
    return post('/cart/change.js', body);
  }
  function addFee(parent) {
    return post('/cart/add.js', { items: [{ id: Number(cfg.variant), quantity: 1, parent_line_key: parent.key,
      properties: { _fee: 'single-row-shipping' } }], sections: sectionIds(), sections_url: window.location.pathname })
      .then(function (res) {
        if (res._ok) return res;
        refused = true;
        console.warn('[SeatFit] single-row shipping add', res.description || res.message);
        return null;
      });
  }

  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var p = plan(cart);
        var steps = p.remove.map(function (l) { return [l, 0]; }).concat(p.fix.map(function (l) { return [l, 1]; }));
        if (!steps.length && !p.add) return null;
        var chain = Promise.resolve(null);
        steps.forEach(function (s, i) {
          var last = i === steps.length - 1 && !p.add;
          chain = chain.then(function () { return change(s[0], s[1], last); });
        });
        if (p.add) chain = chain.then(function () { return addFee(p.add); });
        return chain;
      })
      .then(function (state) { if (state && state.sections) paint(state); })
      .catch(function (e) { console.warn('[SeatFit] single-row shipping reconcile', e); })
      .then(function () { busy = false; if (again) { again = false; reconcile(); } });
  }

  // Signature of the drawer lines: a change means the cart changed, so reconcile.
  function signature() {
    var d = drawer(), sig = [];
    if (!d) return '';
    d.querySelectorAll('.cart-item').forEach(function (row) {
      var input = row.querySelector('[data-quantity-variant-id]');
      sig.push((input ? input.getAttribute('data-quantity-variant-id') : '?') + 'x' + (row.getAttribute('data-quantity') || ''));
    });
    return sig.join('|');
  }
  // While the fee line is in the drawer, the theme's "FREE shipping on orders $85+" bar would contradict it: say
  // what this cart needs instead (a cart without the fee keeps the theme's own wording, which is then true).
  function relabel() {
    var d = drawer();
    if (!d || !cfg.barFrom || !d.querySelector('.cart-item--product-' + cfg.handle)) return;
    var walker = document.createTreeWalker(d, NodeFilter.SHOW_TEXT, null), node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf(cfg.barFrom) >= 0) node.nodeValue = node.nodeValue.replace(cfg.barFrom, cfg.barTo);
    }
  }
  // Arm c only: every "free shipping on $85+" promise on the page (shipping block of the seat page, landing page,
  // home page, FAQ, Shipping & Returns) says what this arm actually gets (owner 21/10, DECISIONS 261021 toi2).
  function swapPromises() {
    if (arm() !== 'c' || !cfg.swaps || !cfg.swaps.length || !document.body) return;
    if (/^\/policies\//.test(window.location.pathname)) return; // the legal policy already states the fee for everyone
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue;
      if (v.indexOf('85') < 0) continue;
      cfg.swaps.forEach(function (p) { if (v.indexOf(p[0]) >= 0) v = v.replace(p[0], p[1]); });
      if (v !== node.nodeValue) node.nodeValue = v;
    }
  }
  var queued = false;
  function onMutate() {
    if (queued) return;
    queued = true;
    setTimeout(function () {
      queued = false;
      try { relabel(); swapPromises(); } catch (e) { /* wording only */ }
      var sig = signature();
      if (sig !== lastDom) { lastDom = sig; reconcile(); }
    }, 150);
  }
  try {
    new MutationObserver(onMutate).observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pageshow', function () { lastDom = null; onMutate(); });
    onMutate();
  } catch (e) {
    console.warn('[SeatFit] single-row shipping init', e);
  }
  window.SeatFitSingleRowShipping = { plan: plan, reconcile: reconcile, config: cfg, arm: arm };
})();
